import { PropertyType } from '../../../models/enum';

export const ReadMode = {
    modelName: 'readMode',
    propertyType: PropertyType.Select,
    label: 'Retrieval mode',
    propertyName: 'readModeProperty',
    required: false,
    icon: 'fa-calendar',
    extraData: {
        options: [
            { key: 0, value: 'By entries dates' },
            { key: 1, value: 'By modification dates' }
        ]
    }
};